export class CityStateLookupError {
  Number: string;
  Source: string;
  Description: string;
  HelpFile: string;
  HelpContext: string;
}
